import { contactFormStyles } from "@insite/content-library/Widgets/ContactUs/ContactForm";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getProp from "@insite/mobius/utilities/getProp";
import { css } from "styled-components";

contactFormStyles.formGridItem = {
    width: 12,
    css: css`
        margin-bottom: 87px !important;
        margin-top: 40px !important;
        position: relative;
        form[id^="contactForm"]{
        width:100%;
        }
        &:before {
            content: "";
            position: absolute;
            height: 100%;
            top: 28;
            left: -25px;
        }
        label {
            margin-left: 20px;
            color: ${getProp("theme.typography.p.color")};
        }
        input {
            border-radius: 40px !important;
            padding: 0 10px 0 18px !important;
            background-color: #f2f2f2 !important;
        }
        textarea {
            border-radius: 28px !important;
            background-color: #f2f2f2 !important;
            resize: vertical !important;
        }
    `,
};

contactFormStyles.submitButton = {
    css: css`
        margin-top: 20px;
        border-radius: 40px;
    `,
};
